/**
 * Common.js
 * Easy access to common globals
 */

export class Common {
    /** @public @type {import("./SettingsManager").SettingsManager} */
    static settings = null;

    /** @public @type {import("./GameDataManager").GameDataManager} */
    static save = null;

    /** @public @type {import("./collisions/CollisionManager").CollisionManager} */
    static collisions = null;

    /** @public @type {import("./CharacterManager").CharacterManager} */
    static characters = null;

    /** @public @type {import("./EnemiesManager").EnemiesManager} */
    static enemies = null;

    /** @public @type {import("./HeroesManager").HeroesManager} */
    static heroes = null;

    /** @public @type {import("./particles/ParticlesManager").ParticlesManager} */
    static particles = null;

    /** @public @type {import("./Grid").Grid} */
    static grid = null;

    /** @public @type {import("pixi_core").GameScene} */
    static scene = null;

    /** @public @type {import("./BubbleFactory").BubbleFactory} */
    static bubbleFactory = null;

    /** @public @type {import("./Shooter").Shooter} */
    static shooter = null;

    /** @public @type {import("../Tutorial/TutorialManager").TutorialManager} */
    static tutorials = null;

    /** @public @type {import("../Tutorial/TutorialPopup").TutorialPopup} */
    static tutorial = null;

    /** @public @type {import("./Level").Level} */
    static currentLevel = null;

    /** @public @type {import("../HUD/EnemySideHud").EnemySideHud} */
    static hudEnemies = null;

    /** @public @type {import("../HUD/HeroSideHud").HeroSideHud} */
    static hudHeroes = null;
}
